import { COLORS, TYPOGRAPHY } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

const styles = createStyleSheet({
  wrapper: {
    height: '100%',
    width: '100%',
    overflowY: 'auto',
    paddingTop: 32,
    paddingBottom: 50,
  },
  box: {
    width: 1100,
    margin: 'auto',
    borderRadius: 4,
    minHeight: 400,
    backgroundColor: COLORS.WHITE.DEFAULT,
  },
  contentWrapper: {
    margin: 'auto',
    width: 1000,
  },
  backButton: {
    marginTop: 32,
  },
  navigation: {
    width: 540,
    minHeight: 400,
    paddingBottom: 120,
    margin: 'auto',
  },
  titlesWrapper: {
    paddingTop: 60,
  },
  title: {
    ...TYPOGRAPHY.H1,
    fontWeight: 'bold',
  },
  subtitle: {
    ...TYPOGRAPHY.BODY3,
    color: COLORS.TEXT.SECONDARY_DEFAULT,
  },
  audienceModesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginTop: 32,
  },
});

export default styles;
